<template>
  <div></div>
</template>

<script>
export default {
  data(){
    return{
      token : '',
      userId : '',
      urlToHDY: "",
      to:'',
    }
  },
  methods:{
    // /verifyToken?Token=' + token,
    // getToken() {
    //   this.$http({
    //       method: 'get',
    //       url: '/unload/verifyToken?Token=' + this.token,
    //       // params: { Token: this.token },
    //     }).then((res) => {
    //       if (res) {
    //             this.userId = res.user.id
    //             console.log("token解析成功！" + this.userId)
    //             this.getUrl()
    //             // go(data.user.id)
    //         } else {
    //             alert("token解析失败！")
    //         }
    //     }).catch((err) => {
    //       console.log("errrrrrrrrrrr",err)
    //         alert("token解析失败了！")
    //       })
    // },
    getUrl() {
      this.$http({
        method: 'get',
        url:'/vmiService/hdyPage/redirect',
        params: {userCode: this.userId , module: this.to},
        }).then((res) => {
          this.urlToHDY = res.data.data;
          this.goto()
        // console.log(res)
        // console.log(res.data)
        // console.log(res.data.data)
        }).catch((err) => {
          // alert("url获取失败了！",err)
        })
    },
    goto(){
      console.log()
        window.open(this.urlToHDY)
        setTimeout(()=>{
          window.location.href = 'about:blank'
          window.close()
        },200)
    }
  },
  mounted(){
    if(this.$route.query.name){
      this.userId = this.$route.query.name
      this.to = this.$route.query.to
      console.log(this.userId)
      this.getUrl()
    }
    // if(this.$route.query.TOKEN){
    //   this.token = this.$route.query.TOKEN
    //   this.getToken()
    //   // console.log(this.token)
    // }else{
    //   this.$alert('TOKEN请检查登录状态', '提示', {
    //     confirmButtonText: '确定',
    //     callback: action => {
    //       window.close()
    //     }
    //   })
    // }
    // if(this.$route.query.to){
    //   this.to = this.$route.query.to
    //   console.log(this.to)
    // }else{
    //   this.$alert('TO请检查登录状态', '提示', {
    //     confirmButtonText: '确定',
    //     callback: action => {
    //       window.close()
    //     }
    //   })
    // }
  }
}
</script>

<style>

</style>